import React from 'react';
import './Modal.scss';
import { GlobalTypes, useGlobalState } from '../../contexts/global';
import ModalChangePassword from './ModalChangePassword';
import ModalDeleteAccount from './ModalDeleteAccount';
import ModalForgottenPassword from './ModalForgottenPassword';
import ModalChooseCourse from './ModalChooseCourse';
import ModalBasket from './ModalBasket';
import Modal from './Modal';
import ModalPaymentInfo from "./ModalPaymentInfo";
import ModalChangeParentPassword from './ModalChangeParentPassword';
import ModalSetParentPassword from './ModalSetParentPassword';
import ModalEnterParentPassword from './ModalEnterParentPassword';
import ModalConfirmOnlineMockExamSubmit from './ModalConfirmOnlineMockExamSubmit';

export type ModalsType =
    | ''
    | 'ModalChangePassword'
    | 'ModalSetParentPassword'
    | 'ModalChangeParentPassword'
    | 'ModalEnterParentPassword'
    | 'ModalDeleteAccount'
    | 'ModalForgottenPassword'
    | 'ModalChooseCourse'
    | 'ModalPaymentInfo'
    | 'ModalBasket'
    | 'ModalConfirmOnlineMockExamSubmit';

const ModalWrapper = () => {
    const { dispatch, state } = useGlobalState();

    const components: { [modalName: string]: JSX.Element } = {
        ModalChangePassword: <ModalChangePassword />,
        ModalSetParentPassword: <ModalSetParentPassword />,
        ModalChangeParentPassword: <ModalChangeParentPassword />,
        ModalEnterParentPassword: <ModalEnterParentPassword />,
        ModalForgottenPassword: <ModalForgottenPassword />,
        ModalDeleteAccount: <ModalDeleteAccount closeModal={closeModal} />,
        ModalChooseCourse: <ModalChooseCourse closeModal={closeModal} />,
        ModalBasket: <ModalBasket closeModal={closeModal} />,
        ModalPaymentInfo: <ModalPaymentInfo closeModal={closeModal}/>,
        ModalConfirmOnlineMockExamSubmit: <ModalConfirmOnlineMockExamSubmit />,
    };

    function closeModal() {
        dispatch({ type: GlobalTypes.ToggleModal, modal: '' });
    }

    return (
        <Modal
            isOpen={!!state.modalComponent}
            close={closeModal}
            className={state.modalComponent === 'ModalConfirmOnlineMockExamSubmit' ? 'is-compact' : ''}
        >
            {components[state.modalComponent]}
        </Modal>
    );
};

export default ModalWrapper;
